import {Card} from './Card'
import {shuffle} from '../Array'

const RANKS = 'A 6 7 8 9 10 J Q K'.split(' ')
const SUITS = 'S C H D'.split(' ')

export class Deck {
    private static instance: Deck
    private readonly cards: {[key: string]: Card}
    private readonly keys: {[key: string]: number} // хранит порядок сортировки

    private constructor() {
        this.cards = {}
        this.keys = {}

        for (let s = 0; s < SUITS.length; s++) {
            for (let r = 0; r < RANKS.length; r++) {
                let rank = RANKS[r]
                let suit = SUITS[s]
                let card = new Card(rank, suit)
                this.cards[card.key] = card
            }
        }
    }

    public static getInstance(): Deck {
        if (!Deck.instance) {
            Deck.instance = new Deck()
        }
        return Deck.instance
    }

    public getShuffledKeys(): string[] {
        let keys = shuffle(Object.keys(this.cards))
        keys.forEach((key, index) => {
            this.keys[key] = index
        })
        return keys
    }

    public getIndexByKey(key: string): number {
        return this.keys[key]
    }

    public getWeight(key: string, trump?: string): number {
        if (this.cards[key]) {
            return this.cards[key].weight(trump ? this.cards[trump] : undefined)
        }
        return 0
    }

    public getSuitWeight(key: string) {
        if (this.cards[key]) {
            return SUITS.indexOf(this.cards[key].suit)
        }
        return 0
    }

    public getCardByKey(key: string): Card {
        return this.cards[key] || new Card('!', '!')
    }

    public setKeys(keys: string[]): void {
        keys.forEach((key, index) => {
            this.keys[key] = index
        })
    }
}
